import React from 'react';
import { DatePicker } from 'antd';
import { FiCalendar } from 'react-icons/fi';
import './styles.scss';
import StatCard from '../../../components/PerformanceDashboard/StatCard';
import EmployeePerformance from '../../../components/PerformanceDashboard/EmployeePerformance';
import AppUsage from '../../../components/PerformanceDashboard/AppUsage';
import Categories from '../../../components/PerformanceDashboard/Categories';

const { RangePicker } = DatePicker;

const PerformanceDashboard = () => {
  const stats = [
    { title: 'Work Hours', value: '716:50' },
    { title: 'Productive Hours', value: '283:00' },
    { title: 'Idle Hours', value: '328:19' },
    { title: 'Unproductive Hours', value: '00:30' },
    { title: 'Utilization', value: '72.04%' },
  ];

  return (
    <div className="performance-dashboard">
      <div className="dashboard-header">
        <h1>Productivity Dashboard</h1>
        <div className="header-actions">
          <RangePicker
            placeholder={['Start Date', 'End Date']}
            suffixIcon={<FiCalendar />}
            className="date-picker"
          />
          <button className="request-btn">Request Monitoring</button>
        </div>
      </div>

      <div className="stats-container">
        {stats.map((stat, index) => (
          <StatCard key={index} title={stat.title} value={stat.value} />
        ))}
      </div>

      <div className="dashboard-content">
        <div className="content-row">
          <EmployeePerformance />
          <AppUsage />
        </div>
        <div className="content-row">
          <Categories />
        </div>
      </div>
    </div>
  );
};

export default PerformanceDashboard;
